(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["emery-shop-the-look"] && !Shopify.designMode) return;
  try {
    const preparedHeroes = new WeakMap();
  const lookSelector = 'button.emery-look-card__button, button.emery-look-trigger';

  function imageIdentity(source) {
    const url = new URL(source, document.baseURI);
    return url.origin + url.pathname + '?v=' + (url.searchParams.get('v') || '');
  }

  function prepareLook(trigger) {
    const drawer = document.getElementById(trigger.getAttribute('aria-controls'));
    const hero = drawer?.querySelector('.emery-look-drawer__hero-image');
    if (!hero || (hero.complete && hero.naturalWidth)) return;
    let original = preparedHeroes.get(hero);
    if (!original) {
      original = { src: hero.src, srcset: hero.srcset, sizes: hero.sizes, preview: false };
      preparedHeroes.set(hero, original);
    }

    const entry = trigger.querySelector('img') || trigger.parentElement.querySelector(':scope > picture img, :scope > img');
    if (!original.preview && entry?.complete && entry.naturalWidth && entry.currentSrc && imageIdentity(entry.currentSrc) === imageIdentity(original.src)) {
      original.preview = true;
      hero.removeAttribute('srcset');
      hero.removeAttribute('sizes');
      hero.src = entry.currentSrc;

      const upgrade = new Image();
      original.upgrade = upgrade;
      upgrade.decoding = 'async';
      upgrade.onload = async () => {
        try { await upgrade.decode(); } catch {}
        if (hero.isConnected) hero.src = upgrade.currentSrc || upgrade.src;
      };
      upgrade.sizes = original.sizes;
      upgrade.srcset = original.srcset;
      upgrade.src = original.src;
    }
    hero.loading = 'eager';
  }

  for (const type of ['pointerover', 'pointerdown', 'focusin']) {
    document.addEventListener(type, event => {
      const trigger = event.target.closest(lookSelector);
      if (trigger) prepareLook(trigger);
    }, { passive: true });
  }

  document.addEventListener('click', event => {
    const trigger = event.target.closest(lookSelector);
    if (trigger) prepareLook(trigger);
  }, true);
  } catch(e) { console.error(e); }
})();

})();
